import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const RichContentPictureList = ({
  content,
  index,
  scrollToBottom,
  listStyle = "none", // Default to no bullets
  itemSpacing = "16px", // Default spacing between items
  maxWidth = "400px", // Default max width for images
}) => {
  useEffect(() => {
    if (scrollToBottom) {
      scrollToBottom();
    }
  }, []);

  return (
    <Box
      key={index}
      sx={{
        width: "100%",
        marginBottom: "0%",
        marginTop: "10px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontWeight: "bold",
          fontSize: "24px",
          color: "white",
        }}
      >
        {content.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontSize: "20px",
          color: "white",
        }}
      >
        {content.subtitle}
      </Typography>
      <Box
        component="ul"
        sx={{
          listStyleType: listStyle,
          paddingLeft: "0",
        }}
      >
        {content.options?.map((lineItem, index) => (
          <Box
            key={index}
            sx={{
              margin: `${itemSpacing} 0`,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img
              width="100%"
              style={{ maxWidth }}
              src={lineItem.url}
              alt={lineItem.text || "Picture list item"}
            />
            <Typography
              sx={{
                fontFamily: "Google Sans",
                fontSize: "16px",
                color: "white",
                marginTop: "8px",
              }}
            >
              {lineItem.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RichContentPictureList;

// Usage:
{
  /*
<RichContentPictureList
  index={0}
  content={{
    type: 'richContent',
    content: {
      type: 'picture_list',
      title: 'My Picture List',
      subtitle: 'A collection of images',
      options: [
        { url: 'https://example.com/image1.jpg', text: 'First image' },
        { url: 'https://example.com/image2.jpg', text: 'Second image' },
      ]
    }}
/>
*/
}
